import { ButtonGroup, Button, Popper, Grow, Paper, ClickAwayListener, MenuList, MenuItem } from '@mui/material';
import React from 'react';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { AssociatedTeamMember, DataRoomUser, UnlockUser } from '../../../shared/models';
import { EntityUtils } from '../../../shared/utils';

interface ITeamMemberActionButtonProps {
	isEmployee: boolean;
	user: DataRoomUser;
	member: AssociatedTeamMember;
	removeAccess: (member: AssociatedTeamMember) => void;
	sendInvite: (member: UnlockUser) => void;
}

type TeamMemberActionItem = keyof typeof TeamMemberActionItemMap;
const TeamMemberActionItemMap = {
	SendInvite: 'Send Invite',
	RemoveAccess: 'Remove Access',
};

export const TeamMemberActionButton: React.FC<ITeamMemberActionButtonProps> = ({
	isEmployee,
	user,
	member,
	removeAccess,
	sendInvite,
}) => {
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef<HTMLDivElement>(null);
	const showInvite = isEmployee || member.lastAccessedOn == undefined || member.lastAccessedOn == null;

	const handleToggle = () => {
		setOpen(prevOpen => !prevOpen);
	};

	const handleClick = (action: TeamMemberActionItem) => {
		const userDto = EntityUtils.GetUnlockUserFromAssociatedTeamMember(member, user);

		switch (action) {
			case 'RemoveAccess':
				removeAccess(member);
				break;
			case 'SendInvite':
				sendInvite(userDto ?? ({} as UnlockUser));
				break;
		}
	};

	const handleClose = (event: Event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
			return;
		}

		setOpen(false);
	};

	const handleMenuItemClick = (
		event: React.MouseEvent<HTMLLIElement, MouseEvent>,
		actionItem: TeamMemberActionItem
	) => {
		setOpen(false);
		handleClick(actionItem);
	};

	return (
		<>
			<ButtonGroup variant="contained" ref={anchorRef} aria-label="split button">
				<Button onClick={handleToggle}>Actions</Button>
				<Button
					size="small"
					aria-controls={open ? 'split-button-menu' : undefined}
					aria-expanded={open ? 'true' : undefined}
					aria-label="select merge strategy"
					aria-haspopup="menu"
					onClick={handleToggle}
				>
					<ArrowDropDownIcon />
				</Button>
			</ButtonGroup>
			<Popper
				open={open}
				style={{ zIndex: 1000, margin: 0 }}
				anchorEl={anchorRef.current}
				role={undefined}
				transition
				disablePortal
			>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{
							transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
						}}
					>
						<Paper>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem>
									{showInvite && (
										<MenuItem onClick={event => handleMenuItemClick(event, 'SendInvite')}>
											{TeamMemberActionItemMap['SendInvite']}
										</MenuItem>
									)}
									<MenuItem onClick={event => handleMenuItemClick(event, 'RemoveAccess')}>
										{TeamMemberActionItemMap['RemoveAccess']}
									</MenuItem>
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</>
	);
};
